// [round-3 port] Copy keys master retired with the Wave-4 §1 ControlBand redesign.
// Release's frozen scaffold (ReviewPageScaffold, DimFilterPanel FU-09a caption) still
// consumes them. Delete when/if that redesign is carried.
export const LEGACY_CONTROLS = {
  filters: 'Filters',
  kpiTitle: 'KPI',
  kpiHelper: 'Choose what to analyze',
  timeframeTitle: 'Timeframe & granularity',
  timeframeHelper: 'Choose when',
  comparisonTitle: 'Comparison',
  comparisonHelper: 'Opt-in comparison',
  dimensionsTitle: 'Dimensions',
  dimensionsHelper: 'Filter, group & split',
  additionalTimeframes: 'Additional timeframes',
} as const
